import { render, staticRenderFns } from "./CrossedMaterialityLegend.vue?vue&type=template&id=2f672d8a&scoped=true"
import script from "./CrossedMaterialityLegend.vue?vue&type=script&lang=js"
export * from "./CrossedMaterialityLegend.vue?vue&type=script&lang=js"
import style0 from "./CrossedMaterialityLegend.vue?vue&type=style&index=0&id=2f672d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f672d8a",
  null
  
)

export default component.exports